const getModuleState = (state) => state.cookies;

export const getMandatoryCookiesList = (state) => getModuleState(state).mandatoryCookiesList;
export const getAnalyticsCookiesList = (state) => getModuleState(state).analyticsCookiesList;
export const getPreferencesCookiesList = (state) => getModuleState(state).preferencesCookiesList;
export const getMarketingCookiesList = (state) => getModuleState(state).marketingCookiesList;
export const consentCookies = (state) => getModuleState(state).modal;
